<ng-select [items]="this.languages" 
           bindLabel="Name" 
           bindValue="Id" 
           placeholder="{{'SELECT_LANGUAGE' | transloco}}"
           (change)="changeLanguage($event)"
           [(ngModel)]="this.selectedLanguage"
           [clearable]="false"
           class="dropdown">
</ng-select>